import React from 'react';
import { Translations } from '../i18n/translations';
import { WomenShapewearIcon, FoamIcon } from './icons';
import { getProductsByCategory } from '../data/products';
interface CategoriesProps {
  t: Translations;
  setPage: (page: 'home' | 'product', slug?: string) => void;
}
export const Categories: React.FC<CategoriesProps> = ({
  t
}) => {
  const fajasCount = getProductsByCategory('fajas').length;
  const accesoriosCount = getProductsByCategory('accesorios').length;
  const scrollToBestSellers = () => {
    const el = document.getElementById('best-sellers');
    if (el) el.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  const categories = [{
    name: t.categories.women,
    label: 'Fajas',
    icon: <WomenShapewearIcon className="w-12 h-12" data-id="element-28" />,
    count: fajasCount
  }, {
    name: t.categories.accessories,
    label: 'Accesorios',
    icon: <FoamIcon className="w-12 h-12" data-id="element-29" />,
    count: accesoriosCount
  }];
  return <section className="bg-beige py-20" data-id="element-30">
      <div className="max-w-7xl mx-auto px-4 lg:px-8" data-id="element-31">
        <div className="flex flex-col items-center mb-16" data-id="element-32">
          <h2 className="text-3xl lg:text-4xl font-serif text-ink mb-6 text-center" data-id="element-33">
            {t.categories.title}
          </h2>
          <div className="w-24 h-[1px] bg-gold" data-id="element-34"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-3xl mx-auto" data-id="element-35">
          {categories.map((cat, i) => <button key={i} onClick={scrollToBestSellers} className="group relative bg-cream rounded-sm p-10 flex flex-col items-center justify-center text-center min-h-[280px] hover:shadow-sm hover:-translate-y-1 transition-soft border border-transparent hover:border-gold/20" data-id="element-36">
              <div className="text-gold/40 group-hover:text-gold transition-colors mb-8 scale-150" data-id="element-37">
                {cat.icon}
              </div>

              <h3 className="font-serif text-xl text-ink mb-2" data-id="element-38">{cat.name}</h3>
              <span className="text-xs uppercase tracking-widest text-ink/50 mb-4" data-id="element-39">
                {cat.count} {cat.count === 1 ? 'producto' : 'productos'}
              </span>

              <span className="text-xs uppercase tracking-widest text-gold group-hover:text-gold-dark transition-colors" data-id="element-40">
                {t.categories.viewMore}
              </span>
            </button>)}
        </div>
      </div>
    </section>;
};